import React, { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Button from '@material-ui/core/Button';
import { resetSearchList, getSearchTerm } from './products';

const NoProducts: FC<{ show: boolean }> = ({ show }) => {
  const dispatch = useDispatch();
  const searchTerm = useSelector(getSearchTerm);
  const { t } = useTranslation();
  return (
    <>
      {show && (
        <div>
          <span style={{ paddingRight: '20px' }}>
            {t('products.no product found')}: <strong>{searchTerm}</strong>.
          </span>
          <Button
            color="secondary"
            onClick={() => {
              dispatch(resetSearchList());
            }}
          >
            CLEAR
          </Button>
        </div>
      )}
    </>
  );
};

export { NoProducts };
